'use client';

import React from 'react';
import Link from './LrLink';
import { usePathname, useParams } from 'next/navigation';
import { useAuthContext } from '../AuthProvider';
import { handleTrackingEventName } from '../../utils/handleTrackingEventName';
import { localizeHref } from '../../utils/localizeHref';

export type { LinkProps, LinkClassKey, LinkClasses } from './Link.types';

const omitProps = (props: any) => {
  const { requireLogin, trackingEventName, requiredRoles, onRequestClose, linkAs, ...rest } = props;
  return rest;
};

const withSubActivePath = (WrappedLink: any) => (props: any) => {
  const pathname = usePathname();
  const params = useParams();
  const locale = (params?.locale as string) || undefined;
  // const { authenticated, setRedirect } = useAuthContext();
  const { setRedirect } = useAuthContext();

  const localizedHref = localizeHref(props.href, locale);

  // Check if the current path is a descendant of the href
  let className = localizedHref && pathname?.startsWith(localizedHref) ? props.subPathActiveClassName : '';
  className = `${props?.className} ${className}`;

  const handleClick = () => {
    // if (authenticated) {
    //   window.location.href = props.href;
    //   return;
    // } else {
    //   setRedirect(props.href);
    //   window.location.href = `${process.env.USER_AUTH_DOMAIN}/api/idp/sfCommunity`;
    // }
    handleTrackingEventName({ trackingEventName: props.trackingEventName, href: props.href });
    setRedirect(props.href);
    window.location.href = `${process.env.SUPPORT_AUTH_DOMAIN}/api/idp/sfCommunity?redirectUri=${encodeURIComponent(
      `${window.location.origin}${pathname}`
    )}`;
  };

  if (props.requireLogin) {
    const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      handleClick();
    };

    return (
      <button onClick={handleButtonClick} style={{ border: 'none', backgroundColor: 'transparent', padding: 0 }}>
        <WrappedLink
          {...omitProps(props)}
          href="#"
          component="span"
          className={`${className} variant-${props.variant}`}
        />
      </button>
    );
  }

  if (props.trackingEventName) {
    return (
      <button
        onClick={() => handleTrackingEventName({ trackingEventName: props.trackingEventName, href: props.href })}
        style={{ border: 'none', backgroundColor: 'transparent', padding: 0 }}>
        <WrappedLink {...omitProps(props)} className={className} component="span" />
      </button>
    );
  }

  return <WrappedLink {...omitProps(props)} />;
};

export default withSubActivePath(Link);
